export const defaultIdleTimeout = 10; // mins